import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"color":_vm.color,"dark":""}},[_c(VCardText,[_c('div',{staticClass:"dashboard-counter"},[_c('div',{staticClass:"dashboard-counter__icon"},[_c(VIcon,{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticClass:"dashboard-counter__info"},[_c('div',{staticClass:"dashboard-counter__title"},[_vm._t("default")],2),_c('div',{staticClass:"dashboard-counter__count"},[_vm._v(_vm._s(_vm.count))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }